import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { formatNumber } from '../../utils/generalFunctions';
import { eliminarPago } from '../../actions/clientes';

const EliminarPago = ({ pago, reestablecerPago }) => {

    const dispatch = useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [pagoData, setPagoData] = useState({
        id: null,
        id_cliente: null,
        concepto: null,
        monto: null
    });

    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarPago({ id: pagoData.id, id_cliente: pagoData.id_cliente }));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setPagoData({ id: null, id_cliente: null, concepto: null, monto: null });
            setEliminarModal(false);
            reestablecerPago(null);
        }
    }

    useEffect(() => {
        if(pago?._id){
            setPagoData({
                id: pago._id,
                id_cliente: pago.id_cliente,
                concepto: pago.concepto,
                monto: pago.monto
            });
            setEliminarModal(true);
        }
    }, [pago]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar abono</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar el abono <strong>{pagoData.concepto}</strong> por <strong>{formatNumber(pagoData.monto, 2, '$ ', '')}</strong>? Esta acción no se puede deshacer.</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary" onClick={() => handleCerrar()}>Cancelar</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-danger" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Eliminar</button>
                    :
                        <button type="button" className="btn btn-danger" onClick={() => handleProcesar()}><i className="fas fa-trash fa-sm"></i> Eliminar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarPago;
